import { Injectable, inject } from '@angular/core';
import {HotToastService} from "@ngneat/hot-toast";
import {InfoToastComponent} from "../../shared/components/info-toast/info-toast.component";
import {ToastTextType, ToastType} from "../../shared/object/toast";
import {TranslateService} from "@ngx-translate/core";

/**
 * ToastService
 * Handle the toast messages
 */
@Injectable({
  providedIn: 'root'
})
export class ToastService {

  /**
   * List of components that HotToastService will handle
   * Each component represents a type of toast, and contains the html template of that toast
   */
  infoToastComponent = InfoToastComponent;

  private toast: HotToastService = inject(HotToastService);
  private translateService: TranslateService = inject(TranslateService);

  private readonly toastHostClassName = 'xplorer-liquid-toast-host';
  private readonly toastHostStyle = {
    background: 'transparent',
    boxShadow: 'none',
    border: '0',
    padding: '0',
    minWidth: '0',
    width: 'auto',
    '--hot-toast-message-margin': '0',
    '--hot-toast-message-display': 'block',
    '--hot-toast-message-justify-content': 'flex-start',
    '--hot-toast-icon-padding-top': '0'
  };

  private showToast(type: ToastType, message: string, duration: number = 2000): void {
    this.toast.close();
    this.toast.show(this.infoToastComponent, {
      duration,
      className: this.toastHostClassName,
      style: this.toastHostStyle,
      data: {type, message}
    });
  }

  showCustomSuccessToast(message: string, duration: number = 2000) {
    this.showToast(ToastType.SUCCESS, message, duration);
  }

  showSuccessToast(messageType: ToastTextType, duration: number = 2000) {
    this.showToast(ToastType.SUCCESS, this.translateService.instant(`toast.messages.${messageType}`), duration);
  }

  showErrorToast(message: string, duration: number = 2000) {
    this.showToast(ToastType.ERROR, message, duration);
  }

  showWarningToast(message: string, duration: number = 2000) {
    this.showToast(ToastType.WARNING, message, duration);
  }

  showInfoToast(message: string, duration: number = 2000) {
    this.showToast(ToastType.INFO, message, duration);
  }

  showSuccessToastWithMessage(message: string, duration: number = 2000) {
    this.showToast(ToastType.SUCCESS, message, duration);
  }

}
